export const lg_account_edit_admin = {
  account_edit_admin_th: {
    title: "แก้ไขข้อมูลผู้ใช้",
    license_type: "ประเภทแผน",
    cb_free: "ฟรี",
    cb_premium: "พรีเมี่ยม",
    sl_company: "เลือกบริษัท",
    sl_department: "เลือกแผนก",
    txt_name: "ชื่อ-นามสกุล",
    email: "อีเมล",
    dtp_birthday: "วันเดือนปีเกิด (YYYY-MM-DD)",
    txt_phone: "หมายเลขโทรศัพท์มือถือ",
    txt_permission: "การอนุญาต",
    btn_cancel: "ยกเลิก",
    btn_save: "บันทึก",
    dialog_select_company: "กรุณาเลือกบริษัท",
    dialog_check_data: "กรุณาตรวจสอบข้อมูล",
    dialog_check_save: "บันทึกข้อมูล",
    dialog_check_save_success: "บันทึกข้อมูลสำเร็จ",
    titlepro: "โปร",
    titlebusiness: "ธุรกิจ",
    titleenterprise: "องค์กร",
    txt_fname: "ชื่อ",
    txt_lname: "นามสกุล",
    rules_commond: "บังคับกรอกข้อมูล",
  },
  account_edit_admin_en: {
    title: "Edit User Information",
    license_type: "Plan type",
    cb_free: "Free",
    cb_premium: "Premium",
    sl_company: "Select company",
    sl_department: "Select department",
    txt_name: "Name",
    email: "Email",
    dtp_birthday: "Date of Birth (YYYY-MM-DD)",
    txt_phone: "Phone number",
    txt_permission: "Permission",
    btn_cancel: "Cancel",
    btn_save: "Save",
    dialog_select_company: "Please select company",
    dialog_check_data: "Please check your information",
    dialog_check_save: "Save",
    dialog_check_save_success: "Save successful",
    titlepro: "Pro",
    titlebusiness: "Business",
    titleenterprise: "Enterprise",
    txt_fname: "First Name",
    txt_lname: "Last Name",
    rules_commond: "This is required",
    
  },
};
